import { grey } from '@mui/material/colors';
import { blue } from '@mui/material/colors';

export const colorGrey = grey[700];
export const colorOrange = '#ff9800'; // Legacy, kept for backward compat
export const colorBlue = blue[600]; // #1e88e5
export const colorPrimary = '#3b82f6'; // Tailwind blue-500
export const colorDarkWhite = grey[200]
export const colorDarkBrown = "#434241";
export const colorDarkOrange = "#c78000";
export const colorDarkBlue = "#1e3a5f";
